import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, change} from 'redux-form';

import {DropzoneField} from 'components/Fields';
import {TextField} from 'components/Fields';
import FormField from 'components/FormField';
import Label from 'components/Label';
import Dropzone from 'components/Dropzone';

import {uploadFile, ACCEPTED_IMAGE_FILE_TYPES} from 'ducks/files';
import {MODALS, editTeamDetails} from 'ducks/teams';
import {storeDataInModal, selectModal} from 'ducks/modals';

import {teamAvatarSignOnEdit} from 'sdk/teams';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  dispatch(
    editTeamDetails(
      {
        id: props.teamId,
        name: values.teamName,
        avatar: values.avatar
      },
      props.modalExtraActions
    )
  );
};

class EditTeamDetailsForm extends React.Component<any> {
  state = {
    files: []
  };

  removeFile = () =>
    this.setState({files: []}, () => this.props.clearFields('avatar'));

  onFileDrop = files => {
    const storeIdentifierAction = identifier =>
      change('editTeamDetails', 'avatar', identifier);

    const storeImageUrlAction = imageUrl =>
      storeDataInModal({
        modalName: MODALS.EDIT_TEAM_DETAILS,
        data: {
          avatarUrl: imageUrl
        }
      });

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.EDIT_TEAM_DETAILS,
        data: {
          uploading: true
        }
      });

    const finishUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.EDIT_TEAM_DETAILS,
        data: {
          uploading: false
        }
      });

    const file = files[0];
    const signSdk = teamAvatarSignOnEdit;
    const signData = {
      filename: file.name,
      fileType: file.type,
      team: this.props.team.id
    };

    this.setState({files: files}, () =>
      this.props.uploadFile({
        file,
        signSdk,
        signData,
        startUploadingAction,
        finishUploadingAction,
        storeIdentifierAction,
        storeImageUrlAction
      })
    );
  };

  render() {
    const {uploading} = this.props;
    const {files} = this.state;

    return (
      <form className="EditTeamDetailsForm" onSubmit={this.props.handleSubmit}>
        <FormField className="editTeamPicture">
          <Field
            name="avatar"
            component={DropzoneField}
            onFileDrop={this.onFileDrop}
            removeFile={this.removeFile}
            multiple={false}
            uploading={uploading}
            files={files}
            acceptedFileTypes={ACCEPTED_IMAGE_FILE_TYPES}
            type={Dropzone.SMALL}
          />
        </FormField>
        <FormField>
          <Label>Team Name</Label>
          <Field name="teamName" component={TextField} />
        </FormField>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const {data: {team}} = selectModal(state, MODALS.TEAM_DETAILS);
  const {data: {uploading}} = selectModal(state, MODALS.EDIT_TEAM_DETAILS);

  const teamName = team.name;

  return {
    initialValues: {teamName},
    team,
    uploading
  };
};

const mapDispatchToProps = {uploadFile};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'editTeamDetails',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(EditTeamDetailsForm)
);
